import React, { PureComponent } from "react";
import styles from "./CapacityPlaning.local.scss";
import { getTimeByDurationFormat } from "../../utils";
import { BudgetIcon, EntityIcon, PelletGoIcon } from "../Common/Icons";
import { Tooltip } from "antd";
import classNames from "classnames";
import _ from "i18n";
import { isManagerAccess, isAdminAccess, isSuperAdminAccess } from "Utils";

export class CapacityPlaningTable extends PureComponent {
  render() {
    const {
      dataModel,
      columns,
      totalModel,
      collaborator,
      loggedAs,
      spaceAs
    } = this.props;

    // const { erpData } = this.props;
    // let erpCollaborators = erpData && erpData.items.clients;
    // const dataErp = erpCollaborators ? erpCollaborators : [];
    return (
      <div className={styles.div}>
        <table className={styles.table}>
          <tbody className={styles.thead}>
            <tr>
              <td
                rowSpan="2"
                colSpan="2"
                className={styles.column_group}
                style={{
                  position: "sticky",
                  left: "0",
                  zIndex: "3",
                  height: "82px"
                }}
              />
              {columns.map(x => (
                <td
                  colSpan="3"
                  className={styles.column_group}
                  style={{ textTransform: "uppercase" }}
                  key={x["label"]}
                >
                  {x["label"]}
                </td>
              ))}
            </tr>
            <tr>
              {columns.map((x, i) =>
                x["children"].map(y => (
                  <td
                    className={styles.columns_group}
                    style={{
                      borderRadius:
                        y === "budget"
                          ? "5px 2px 2px 5px"
                          : y === "qp"
                            ? "2px 5px 5px 2px"
                            : "2px 2px 2px 2px",
                      textTransform: "uppercase"
                    }}
                    key={y + i}
                  >
                    {y}
                  </td>
                ))
              )}
            </tr>
          </tbody>
          <tbody className={styles.tbody}>
            <tr>
              <td
                rowSpan="2"
                className={styles.column_client}
                style={{
                  background: "#C9CCD0",
                  position: "sticky",
                  left: "0",
                  zIndex: "1"
                }}
              >
                {"Total : " + dataModel.length}
              </td>
              <td
                style={{
                  background: "#C9CCD0",
                  position: "sticky",
                  left: "197px",
                  zIndex: "1",
                  minWidth: "120px"
                }}
              >
                <div className={styles.all}>
                  {totalModel["nbrCollaborator"]}
                  <div style={{ width: "15px", marginLeft: "2px" }}>
                    <img alt="" src="/img/icons/profil.svg" />
                  </div>
                </div>
              </td>
              {columns.map(x =>
                x["children"].map(y => (
                  <td
                    className={styles.tab}
                    style={{
                      background: "#C9CCD0",
                      width: ["budget", "real"].includes(y)
                        ? "100px!important"
                        : "",
                      borderRadius:
                        x === "super" && y === "qp" ? "0px 5px 5px 0px" : ""
                    }}
                    key={x + y}
                  >
                    {y === "qp" && totalModel["all"][x["label"]][y] <= 100
                      ? this.renderSpanColor(
                          totalModel["all"][x["label"]][y],
                          y
                        )
                      : ""}
                    {y === "qp" && totalModel["all"][x["label"]][y] > 100
                      ? this.renderTreeTdComponent(
                          totalModel["all"][x["label"]]["real"] -
                            totalModel["all"][x["label"]]["budget"],
                          "over"
                        )
                      : this.renderTreeTdComponent(
                          totalModel["all"][x["label"]][y],
                          y
                        )}
                  </td>
                ))
              )}
            </tr>
            <tr>
              <td
                style={{
                  background: "#C9CCD0",
                  position: "sticky",
                  left: "197px",
                  zIndex: "1",
                  minWidth: "120px"
                }}
              >
                <Tooltip placement="bottom" title={collaborator.name}>
                  {collaborator.name && collaborator.name.length >= 17
                    ? collaborator.name.slice(0, 14) + "..."
                    : collaborator.name}
                </Tooltip>
              </td>
              {columns.map(x =>
                x["children"].map(y => (
                  <td
                    className={styles.tab}
                    style={{
                      background: "#C9CCD0",
                      width: y === "budget" ? "100px" : "",
                      borderRadius:
                        x === "super" && y === "qp" ? "0px 5px 5px 0px" : ""
                    }}
                    key={x + y}
                  >
                    {y === "qp" &&
                    totalModel["collaborator"][x["label"]][y] <= 100
                      ? this.renderSpanColor(
                          totalModel["collaborator"][x["label"]][y],
                          y
                        )
                      : ""}
                    {y === "qp" &&
                    totalModel["collaborator"][x["label"]][y] > 100
                      ? this.renderTreeTdComponent(
                          totalModel["collaborator"][x["label"]]["real"] -
                            totalModel["collaborator"][x["label"]]["budget"],
                          "over"
                        )
                      : this.renderTreeTdComponent(
                          totalModel["collaborator"][x["label"]][y],
                          y
                        )}
                  </td>
                ))
              )}
            </tr>
          </tbody>
          {dataModel.map((item, i) => (
            <tbody className={styles.tbody} key={i}>
              <tr key={i}>
                <td
                  rowSpan="2"
                  className={styles.column_client}
                  style={{
                    position: "sticky",
                    left: "0",
                    zIndex: "1"
                  }}
                >
                  <div className={styles.client_content}>
                    <div style={{ textAlign: "left", marginLeft: "10px" }}>
                      <div
                        className={
                          item["client"] &&
                          item["client"].length > 29 &&
                          item["client"].length < 35
                            ? classNames(styles.client_name, styles.label_wrap)
                            : item["client"] && item["client"].length > 34
                              ? classNames(
                                  styles.client_name,
                                  styles.label_wrap_medium_size
                                )
                              : styles.client_name
                        }
                        key={i}
                      >
                        {item["client"]}
                      </div>
                      <div>
                        {item.attachedClients && item.attachedClients.length ? (
                          <div className={styles.attached_client}>
                            {this.getTwoAssociatedClientName(
                              item.attachedClients
                            ).map((itemName, index) => (
                              <div>
                                <span
                                  className={
                                    itemName.clientName &&
                                    itemName.clientName.length > 20 &&
                                    itemName.clientName.length < 40
                                      ? classNames(
                                          styles.label_wrap,
                                          styles.attached_client_name
                                        )
                                      : itemName.clientName &&
                                        itemName.clientName.length > 39
                                        ? classNames(
                                            styles.label_wrap_medium_size,
                                            styles.attached_client_name
                                          )
                                        : styles.attached_client_name
                                  }
                                >
                                  {"• " + itemName.clientName}
                                </span>
                                <br />
                                {(item.attachedClients &&
                                  item.attachedClients.length > 3) &
                                (index === 1) ? (
                                  <span className={styles.attached_client_more}>
                                    {" "}
                                    {_("and")}{" "}
                                    <b>{item.attachedClients.length - 2} </b>{" "}
                                    {_("more")}
                                    <b>{"..."}</b>
                                  </span>
                                ) : (
                                  ""
                                )}
                              </div>
                            ))}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div
                      className={styles.redirection}
                      style={{
                        marginRight:
                          isManagerAccess(loggedAs, spaceAs) ||
                          isAdminAccess(loggedAs, spaceAs) ||
                          isSuperAdminAccess(loggedAs, spaceAs)
                            ? "35px"
                            : "2px"
                      }}
                    >
                      {item.attachedClients && item.attachedClients.length ? (
                        <Tooltip
                          placement="right"
                          title={
                            <div
                              style={{
                                textAlign: "left"
                              }}
                            >
                              <p>
                                {_("attachedClients")}
                                {" : "}
                              </p>
                              {item.attachedClients.map(item => (
                                <p>{"- " + item.clientName}</p>
                              ))}
                            </div>
                          }
                        >
                          <div style={{ height: "18px" }}>
                            <EntityIcon
                              className={styles.info_icon}
                              color={"#6d7f92"}
                            />
                          </div>
                        </Tooltip>
                      ) : (
                        ""
                      )}
                      {/*{dataErp.map(erp => {*/}
                      {/*  return erp[row.id] && erp[row.id].erpId ? (*/}
                      {/*    <Tooltip*/}
                      {/*      placement="right"*/}
                      {/*      title={*/}
                      {/*        <div style={{ background: "white" }}>*/}
                      {/*          <p>*/}
                      {/*            {_("importedFrom")} : {erp[row.id].erpLabel}*/}
                      {/*          </p>*/}
                      {/*          <p>*/}
                      {/*            {_("identifier")} : {erp[row.id].erpId}*/}
                      {/*          </p>*/}
                      {/*        </div>*/}
                      {/*      }*/}
                      {/*    >*/}
                      {/*<img*/}
                      {/*  src="/img/icons/info.svg"*/}
                      {/*  alt="text"*/}
                      {/*  className={styles.info_icon}*/}
                      {/*/>*/}
                      {/*    </Tooltip>*/}
                      {/*  ) : (*/}
                      {/*    ""*/}
                      {/*  );*/}
                      {/*})}*/}
                      {/*  </span>*/}
                      {/*</span>*/}
                    </div>
                    {(isManagerAccess(loggedAs, spaceAs) ||
                      isAdminAccess(loggedAs, spaceAs) ||
                      isSuperAdminAccess(loggedAs, spaceAs)) && (
                      <div className={styles.redirection}>
                        <Tooltip
                          placement="bottom"
                          title={_("visualiser Time Sheet")}
                        >
                          <span
                            onClick={() =>
                              this.props.handleRedirectToTimeSheet(
                                item["idClient"],
                                item["client"]
                              )
                            }
                            key={i}
                          >
                            <PelletGoIcon />
                          </span>
                        </Tooltip>
                        <Tooltip placement="bottom" title={_("configBudget")}>
                          <span
                            onClick={() =>
                              this.props.handleRedirectToBudgetSetting(
                                item["idClient"],
                                item["client"]
                              )
                            }
                            key={i}
                          >
                            <BudgetIcon
                              color={"#3c4e64"}
                              width={17}
                              height={17}
                            />
                          </span>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </td>
                <td
                  className={styles.column_collaborator}
                  style={{
                    position: "sticky",
                    left: "197px",
                    zIndex: "1",
                    minWidth: "120px"
                  }}
                  key={i}
                >
                  <div className={styles.all} key={i}>
                    {item["nbrCollaborator"]}
                    <div style={{ width: "15px", marginLeft: "2px" }}>
                      <img alt="" src="/img/icons/profil.svg" />
                    </div>
                  </div>
                </td>
                {columns.map(x =>
                  x["children"].map(y => (
                    <td
                      className={styles.tab}
                      style={{
                        background:
                          y === "budget"
                            ? "#DEE2E6"
                            : y === "real"
                              ? "#f1f2f4"
                              : "#f8f9fa",
                        width: y === "qp" ? "100px" : "",
                        borderRadius:
                          x === "super" && y === "qp" ? "0px 5px 5px 0px" : ""
                      }}
                      key={x + y}
                    >
                      {y === "qp" &&
                      item["children"]["all"][x["label"]][y] <= 100
                        ? this.renderSpanColor(
                            item["children"]["all"][x["label"]][y],
                            y
                          )
                        : ""}
                      {y === "qp" &&
                      item["children"]["all"][x["label"]][y] > 100
                        ? this.renderTreeTdComponent(
                            item["children"]["all"][x["label"]]["real"] -
                              item["children"]["all"][x["label"]]["budget"],
                            "over"
                          )
                        : this.renderTreeTdComponent(
                            item["children"]["all"][x["label"]][y],
                            y
                          )}
                    </td>
                  ))
                )}
              </tr>
              <tr>
                <td
                  className={styles.column_collaborator}
                  style={{
                    position: "sticky",
                    left: "197px",
                    zIndex: "1",
                    minWidth: "120px"
                  }}
                >
                  <Tooltip placement="bottom" title={collaborator.name}>
                    {collaborator.name && collaborator.name.length >= 17
                      ? collaborator.name.slice(0, 14) + "..."
                      : collaborator.name}
                  </Tooltip>
                </td>
                {columns.map(x =>
                  x["children"].map(y => (
                    <td
                      className={styles.tab}
                      style={{
                        background:
                          y === "budget"
                            ? "#DEE2E6"
                            : y === "real"
                              ? "#f1f2f4"
                              : "#f8f9fa"
                      }}
                      key={y + x}
                    >
                      {y === "qp" &&
                      item["children"]["collaborator"][x["label"]][y] <= 100
                        ? this.renderSpanColor(
                            item["children"]["collaborator"][x["label"]][y],
                            y
                          )
                        : ""}
                      {y === "qp" &&
                      item["children"]["collaborator"][x["label"]][y] > 100
                        ? this.renderTreeTdComponent(
                            item["children"]["collaborator"][x["label"]][
                              "real"
                            ] -
                              item["children"]["collaborator"][x["label"]][
                                "budget"
                              ],
                            "over"
                          )
                        : this.renderTreeTdComponent(
                            item["children"]["collaborator"][x["label"]][y],
                            y
                          )}
                    </td>
                  ))
                )}
              </tr>
            </tbody>
          ))}
        </table>
      </div>
    );
  }

  getTwoAssociatedClientName = attachedClients => {
    if (attachedClients.length > 3) {
      return attachedClients.slice(0, 2);
    } else {
      return attachedClients;
    }
  };
  renderTreeTdComponent = (fields, col) => {
    return col !== "qp" ? (
      <div style={{ color: col === "over" ? "red" : "" }}>
        {col === "over" ? "+" : ""}
        {getTimeByDurationFormat(fields)}
      </div>
    ) : fields === 0 ? (
      fields + "%"
    ) : fields > 100 ? (
      "+100%"
    ) : (
      fields.toFixed(2).replace(".", ",") + "%"
    );
  };
  renderSpanColor = fields => {
    return fields === 0 ? (
      <span className={styles.null_span} />
    ) : fields > 100 ? (
      <span className={styles.over_span} />
    ) : fields > 80 ? (
      <span className={styles.advanced_span} />
    ) : (
      <span className={styles.active_span} />
    );
  };
}
export default CapacityPlaningTable;



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningTable.js